import { setPageStateById } from '../PageContext';

export const addRequiredWidgets = (setState: setPageStateById) => () => {
  setState('ADD_REQUIRED_WIDGETS', (s) => ({
    ...s,
    widgets: [...s.widgets, ...s.requiredWidgets],
    requiredWidgets: [],
  }));
};
